import type { OverviewFeatureConfig } from '../../types/features/OverviewFeatureConfig';

export const overview: OverviewFeatureConfig = {
    highlight: {
        showRemainingTerm: false,
        showRemainingInstallmentsCount: true,
    },
};
